// @ts-ignore
import React from "react";

import { useIntl } from "react-intl";

// @ts-ignore
import ThreeAlternatingImageText from "@/patterns/three-alternating-image-text/src/three-alternating-image-text";

const SideBySideAlternatingImageAndTextSectionPaidLpJswTracker = () => {
    const intl = useIntl();
    const firstImageTextSideSectionObject = {
        imageSrc:
            "https://wac-cdn-2.atlassian.com/dam/jcr:ac9d974d-f4aa-44f6-acf3-85dd547e2422/seamless-integration2x.png?cdnVersion=ece",
        headerText: intl.formatMessage({
            id: "JiraSoftwarePage.paidLpJswTracker.sideBySideImageTextSide.headerText1",
            defaultMessage: "Build better software with seamless integrations"
        }),
        bodyText: intl.formatMessage({
            id: "JiraSoftwarePage.paidLpJswTracker.sideBySideImageTextSide.bodyText1",
            defaultMessage:
                "Help your team work better together by connecting Jira Software with Bitbucket, Github, Jenkins, or your favorite tools."
        }),
        imageAltText: intl.formatMessage({
            id: "JiraSoftwarePage.paidLpJswTracker.sideBySideImageTextSide.imageAltText1",
            defaultMessage: "Slack integration"
        })
    };
    const secondImageTextSideSectionObject = {
        imageSrc:
            "https://wac-cdn-2.atlassian.com/dam/jcr:66566086-69b6-4ff7-98b5-1f698a85f9b2/automation2xpng.png?cdnVersion=ece",
        headerText: intl.formatMessage({
            id: "JiraSoftwarePage.paidLpJswTracker.sideBySideImageTextSide.headerText2",
            defaultMessage: "Connect your entire workflow with automation"
        }),
        bodyText: intl.formatMessage({
            id: "JiraSoftwarePage.paidLpJswTracker.sideBySideImageTextSide.bodyText2",
            defaultMessage:
                "Whether your team is using Bitbucket, Slack, or any other third-party, automation keeps Jira up to date so you don't have to."
        }),
        imageAltText: intl.formatMessage({
            id: "JiraSoftwarePage.paidLpJswTracker.sideBySideImageTextSide.imageAltText2",
            defaultMessage: "Automation"
        })
    };
    const thirdImageTextSideSectionObject = {
        imageSrc:
            "https://wac-cdn-2.atlassian.com/dam/jcr:c2355274-dff8-48ab-ac0b-c3deb269471c/automation-rules2x.png?cdnVersion=ece",
        headerText: intl.formatMessage({
            id: "JiraSoftwarePage.paidLpJswTracker.sideBySideImageTextSide.headerText3",
            defaultMessage: "Automate in seconds & never start from scratch"
        }),
        bodyText: intl.formatMessage({
            id: "JiraSoftwarePage.paidLpJswTracker.sideBySideImageTextSide.bodyText3",
            defaultMessage:
                "Jira comes with built-in automation rule templates so you can get started easily, whether you want to auto-assign bugs or automate releases in a few clicks."
        }),
        imageAltText: intl.formatMessage({
            id: "JiraSoftwarePage.paidLpJswTracker.sideBySideImageTextSide.imageAltText3",
            defaultMessage: "Automation rules"
        })
    };

    return (
        <ThreeAlternatingImageText
            backgroundImage={
                "linear-gradient(225deg, #deebff 0%, #ffffff 100%)"
            }
            horizontalRuleColor={"#b2d4ff"}
            imageWidth={"100%"}
            //Row 1
            imageTextSideRowOnePaddingBelowLargeScreen={"32px 0 16px"}
            rowOneHeader={firstImageTextSideSectionObject.headerText}
            rowOneBody={firstImageTextSideSectionObject.bodyText}
            rowOneImageLink={firstImageTextSideSectionObject.imageSrc}
            rowOneImageAltText={firstImageTextSideSectionObject.imageAltText}
            //Row 2
            imageTextSideRowTwoPadding={"16px 0"}
            rowTwoHeader={secondImageTextSideSectionObject.headerText}
            rowTwoBody={secondImageTextSideSectionObject.bodyText}
            rowTwoImageLink={secondImageTextSideSectionObject.imageSrc}
            rowTwoImageAltText={secondImageTextSideSectionObject.imageAltText}
            //Row 3
            imageTextSideRowThreePaddingBelowLargeScreen={"16px 0 32px"}
            rowThreeHeader={thirdImageTextSideSectionObject.headerText}
            rowThreeBody={thirdImageTextSideSectionObject.bodyText}
            rowThreeImageLink={thirdImageTextSideSectionObject.imageSrc}
            rowThreeImageAltText={thirdImageTextSideSectionObject.imageAltText}
        />
    );
};

export default SideBySideAlternatingImageAndTextSectionPaidLpJswTracker;
